import PropTypes from 'prop-types';

const TriangleUp = ({ color, size, ...props }) => (
    <svg viewBox="0 0 10 10" width={size} height={size} {...props}>
        <path
            d="M8.92 6.007 5.193 2.085A.27.27 0 0 0 5 2a.26.26 0 0 0-.194.085L1.08 6.007a.303.303 0 0 0-.06.315q.032.08.101.13a.27.27 0 0 0 .153.048h7.45a.27.27 0 0 0 .153-.048.3.3 0 0 0 .101-.13.3.3 0 0 0-.06-.315"
            fill={color}
        />
    </svg>
);

export default TriangleUp;

TriangleUp.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
